import * as THREE from 'three';

const CurveGridAccuracy: number = 1;
// const MetOffset: number = 10;
// const MidOffset: number = 15;
// const VerticalBandwidth: number = 18;

export function LiftMesh(insole: THREE.Mesh, curveGroup: THREE.Group | null, markers: THREE.Group | null) {
    if (!(curveGroup instanceof THREE.Group) || curveGroup.children.length === 0) {
        return;
    }

    const pointMarkers = curveGroup.children.filter((child) => child instanceof THREE.Mesh);
    if (pointMarkers.length < 2) return;

    curveGroup.updateMatrixWorld(true);
    insole.updateMatrixWorld(true);
    const mainCurvePoints = pointMarkers.map((child) => {
        const worldPosition = new THREE.Vector3();
        child.getWorldPosition(worldPosition);
        // Geometry vertices are local to `insole`; convert the curve to the
        // same coordinate system before using it to update those vertices.
        return insole.worldToLocal(worldPosition);
    });
    const curve = new THREE.CatmullRomCurve3(mainCurvePoints, false);
    const curvePoints = curve.getSpacedPoints(Math.round(curve.getLength() / CurveGridAccuracy));
    const curveBBX = new THREE.Box3().setFromPoints(mainCurvePoints);

    const curveNormals = NormalOnCurvePoints(curvePoints);

    const positions = insole.geometry.getAttribute('position');
    insole.geometry.computeBoundingBox();
    const floorY = insole.geometry.boundingBox?.min.y ?? 0;

    for (let index = 0; index < positions.count; index++) {
        const p = new THREE.Vector3().fromBufferAttribute(positions, index);

        const t = Math.abs(p.z - curveBBX.min.z) / CurveGridAccuracy;
        const i0 = Math.floor(t);
        if (i0 < 0 || i0 >= curvePoints.length || !curveNormals[i0]) continue;
        const i1 = Math.min(i0 + 1, curvePoints.length - 1);
        const f = THREE.MathUtils.clamp(t - i0, 0, 1);

        const curveY = THREE.MathUtils.lerp(curvePoints[i0].y, curvePoints[i1].y, f);
        const normal = curveNormals[i0].clone().lerp(curveNormals[i1], f).normalize();
        const disZtillFloor = Math.abs(p.y - floorY);
        const py = normal.multiplyScalar(disZtillFloor);
        positions.setXYZ(index, p.x, curveY + py.y, p.z + py.z);
    }

    // if (markers && markers.children.length>0) {
    //     insole.geometry.computeBoundingBox();
    //     const center = new THREE.Vector3();
    //     insole.geometry.boundingBox?.getCenter(center);
    //     insole.geometry.translate(-center.x, -center.y, -center.z);

    //     var calcPoint = markers.children.filter((item) => item.name === 'Calcaneous')[0].position;
    //     var met2Point = markers.children.filter((item) => item.name === 'Metatarsal_2')[0].position;

    //     const metAxis = new THREE.Vector3().subVectors(calcPoint, met2Point);
    //     const xAxis = new THREE.Vector3(1, 0, 0);

    //     const deviation = metAxis.angleTo(xAxis);
    //     insole.geometry.rotateY(Math.abs(deviation) - Math.PI / 2);
    //     insole.geometry.translate(center.x, center.y, center.z);
    // }

    positions.needsUpdate = true;
    insole.geometry.computeVertexNormals();
}

export function NormalOnCurvePoints(points: THREE.Vector3[]): THREE.Vector3[] {
    const normals: THREE.Vector3[] = [];
    if (points.length == 0) return normals;
    for (let i = 0; i < points.length - 1; i++) {
        const p = points[i];
        const v1 = points[i + 1].clone().sub(p);
        const v2 = v1.clone();
        v1.z = v2.y * -1;
        v1.y = v2.z;
        v1.normalize();
        normals.push(v1);
    }
    normals.push(normals[normals.length - 1]);
    return normals;
}

export function createShoeMarker(position: THREE.Vector3, name: string, color: number = 0x33ff33): THREE.Mesh {
    const geom = new THREE.SphereGeometry(1);
    const mat = new THREE.MeshStandardMaterial({ color: color });

    const marker = new THREE.Mesh(geom, mat);
    marker.name = name;
    marker.position.copy(position);

    return marker;
}

export const drawLinesBetweenPoints = (points: THREE.Vector3[], group: THREE.Group, color: number, sideName: string, sideIndex: number, lineThickness: number = 0.6):
    void => {
    if (!points || points.length < 2) return;



    const oldLines = group.children.filter(
        (child: THREE.Object3D) => child.name && child.name.endsWith(`Lines_${sideName}`)
    );
    oldLines.forEach((line: THREE.Object3D) => group.remove(line));

    // const vertices: THREE.Vector3[] = points.map((point: THREE.Vector3) => {
    //   if (point instanceof THREE.Vector3) {
    //     return point.clone();
    //   } else {
    //     return new THREE.Vector3(point.x, point.y, point.z);
    //   }
    // });

    const curve = new THREE.CatmullRomCurve3(points);
    const tubeGeometry = new THREE.TubeGeometry(curve, 100, lineThickness, 8, false);
    const material = new THREE.MeshStandardMaterial({
        color: color,
        emissive: color,
        emissiveIntensity: 0.2,
    });
    const tube = new THREE.Mesh(tubeGeometry, material);
    tube.name = `${group.name.includes('Inside') ? 'Inside' : 'Outside'}Lines_${sideName}`;

    group.add(tube);
}

function AddDistance(pnt1: THREE.Vector3, pnt2: THREE.Vector3, mdl: string, addLabel: boolean = true):
    [number, THREE.Line] {
    var dist = Math.round(Math.sqrt(Math.pow(pnt1.x - pnt2.x, 2) + Math.pow(pnt1.y - pnt2.y, 2) + Math.pow(pnt1.z - pnt2.z, 2)));

    var line = AddDimension(pnt1, pnt2, mdl, true);

    //         LeaderAndText lbl = new LeaderAndText((pnt1 + pnt2) / 2,
    //     dist + " mm", new Font("Tahoma", 8.25f), Color.White, new Vector2(0, 40));

    // lbl.FillColor = mdl as FPIColors;

    // if (addLabel)
    //     _labels.Add(lbl);

    return [dist, line];
}

function AddDimension(pnt1: THREE.Vector3, pnt2: THREE.Vector3, modelType: string, isDistance: boolean = false): THREE.Line {
    const geometry = new THREE.BufferGeometry().setFromPoints([pnt1, pnt2]);
    const material = new THREE.LineBasicMaterial({
        color: isDistance ? 'Black' : FPIColors[modelType as keyof typeof FPIColors],
        linewidth: isDistance ? 1 : 4
    });
    var line = new THREE.Line(geometry, material);

    return line;
}

function AddAngle(pnt0: THREE.Vector3, pnt1: THREE.Vector3, pnt2: THREE.Vector3, mdl: string) {
    //         Plane nplane = new Plane(pnt0, pnt1, pnt2);

    //         AngularDim angularDim = new AngularDim(nplane, pnt0, pnt1, pnt2, ((pnt1 + pnt0) / 2 + (pnt2 + pnt0) / 2) / 2, 0.25);
    // //angularDim.TextSuffix = "°";
    // angularDim.Precision = 0;

    //         LeaderAndText lbl = new LeaderAndText(pnt0,
    //     Math.Round(angularDim.Distance) + " °", new Font("Tahoma", 8.25f), Color.White, new Vector2D(0, 40));

    // lbl.FillColor = mdl as FPIColors;
    // _labels.Add(lbl);

    // return angularDim;
}

export function CreateJoints(points: THREE.Vector3[], modelType: string): THREE.Group {
    const output: THREE.Group = new THREE.Group();
    points.forEach(pnt => {
        const geom = new THREE.SphereGeometry(2.5);
        const mat = new THREE.MeshStandardMaterial({ color: (FPIColors[modelType as keyof typeof FPIColors]) });
        const joint = new THREE.Mesh(geom, mat);
        joint.name = modelType;
        joint.position.copy(new THREE.Vector3(pnt.x, pnt.y, pnt.z));
        output.add(joint);
    })
    return output;
}

export function DrawTalarHead(pnts: THREE.Vector3[]): THREE.Group {
    var outputEnt = new THREE.Group();
    var scr = -100;

    var pntsmesh = CreateJoints(pnts, "TalarHead");
    outputEnt.add(pntsmesh);

    var dim1 = AddDimension(pnts[2], pnts[3], "TalarHead");
    outputEnt.add(dim1);

    // try {
    // var pn0 = pnts[0] + (pnts[0] - pnts[1]) * 10;
    // var pn1 = pnts[1] + (pnts[1] - pnts[0]) * 10;

    // var l1 = new Line(pn0, pn1);

    // //var p0 = new Point3D(pnts[0].X, pnts[0].Y);
    // //var p1 = new Point3D(pnts[1].X, pnts[1].Y);
    // var p0 = new Vector3(pn0.X, pn0.Y);
    // var p1 = new Vector3(pn1.X, pn1.Y);
    // var p2 = new Vector3(pnts[2].x, pnts[2].z);
    // var p3 = new Vector3(pnts[3].x, pnts[3].z);

    // UtilityEx.IntersectionLineLine(new Line(p0, p1), new Line(p2, p3), out var p);

    // var pt = new Point3D(p.x, p.y, 1000);
    // var l2 = new Line(p, pt);

    // UtilityEx.IntersectionLineLine(l1, l2, out var pp);

    // var dim2 = AddDimension(pnts[0], pp, "TalarHead", mcolor);
    // var dim3 = AddDimension(pnts[1], pp, "TalarHead", mcolor);

    // outputEnt.Add(dim2);
    // outputEnt.Add(dim3);

    // var (d1, ent1) = AddDistance(pnts[0], pp, mcolor, "TalarHead");
    // var (d2, ent2) = AddDistance(pnts[1], pp, mcolor, "TalarHead");

    // var dif = Math.Abs(d1 - d2);
    // var (dl, entl) = AddDistance(pnts[0], pnts[1], "TalarHead", false);
    // var dn = dif / dl;

    // outputEnt.add(entl);

    // scr = Math.round(6 * (dn + -0.2));
    // }
    // catch (Exception) {
    var tdim = AddDimension(pnts[0], pnts[1], "TalarHead");
    outputEnt.add(tdim);
    // }
    return outputEnt;
}

export function DrawArchHeight(pnts: THREE.Vector3[]) {
    var outputEnt = new THREE.Group();
    var pntsmesh = CreateJoints(pnts, "ArchHeight");

    var dim1 = AddDimension(pnts[0], pnts[1], "ArchHeight");
    var dim2 = AddDimension(pnts[1], pnts[2], "ArchHeight");
    var dim3 = AddDimension(pnts[2], pnts[3], "ArchHeight");

    // var w = new Line(pnts[0], pnts[3]);
    // w.ClosestPointTo(pnts[1], out double t);

    var [d1, ent1] = AddDistance(pnts[0], pnts[3], "ArchHeight");
    // var [d2, ent2] = AddDistance(pnts[1], w.PointAt(t), "ArchHeight");

    // var scr = (int)Math.Round(ArchHeightItems[0].CoefVal * ((d1 / d2) + ArchHeightItems[0].ConstantVal));
    outputEnt.add(pntsmesh, ent1, dim1, dim2, dim3);
    return outputEnt;
}

export function DrawRearFootAlign(pnts: THREE.Vector3[]) {
    var pntsmesh = CreateJoints(pnts, "RearFootAlignment");

    var d1 = AddDimension(pnts[0], pnts[1], "RearFootAlignment");
    var d2 = AddDimension(pnts[1], pnts[2], "RearFootAlignment");

    var angle = AddAngle(pnts[1], pnts[0], pnts[2], "RearFootAlignment");

    var outputEnt = new THREE.Group().add(pntsmesh, d1, d2);
    return outputEnt;
}

export function DrawTransversePlane(pnts: THREE.Vector3[]) {
    var outputEnt = new THREE.Group();
    var pntsmesh = CreateJoints(pnts, "TransversePlane");

    var d1 = AddDimension(pnts[0], pnts[1], "TransversePlane");
    AddDistance(pnts[0], pnts[1], "TransversePlane");

    outputEnt.add(pntsmesh, d1);
    return outputEnt;
}

export function DrawCalcaneousPos(pnts: THREE.Vector3[]) {
    var outputEnt = new THREE.Group();
    var pntsmesh = CreateJoints(pnts, "CalcaneousPosition");

    var d1 = AddDimension(pnts[0], pnts[1], "CalcaneousPosition");
    var d2 = AddDimension(pnts[2], pnts[3], "CalcaneousPosition");
    var d3 = AddDimension(pnts[2], pnts[0], "CalcaneousPosition");
    var d4 = AddDimension(pnts[2], pnts[1], "CalcaneousPosition");

    // List<Point3D> newPnts = new List<Point3D>();
    // for (int i = 0; i < pnts.Count; i++)
    // {
    //     Point3D p = new Point3D(pnts[i].X, pnts[i].Y, pnts[i].Z);
    //     p.TransformBy(new Rotation((Math.PI / 2) - Math.Abs(Deviation), Vector3D.AxisMinusZ, pnts[0]));
    //     newPnts.Add(p);
    // }

    // var pnts1 = new Point3D(newPnts[1].X, newPnts[0].Y, newPnts[0].Z);
    // var pnts2 = new Point3D(newPnts[2].X, newPnts[0].Y, newPnts[2].Z);
    // //var pnts2 = new Point3D(pnts[2].X, pnts[0].Y, pnts[2].Z);
    // var pnts3 = new Point3D(newPnts[3].X, newPnts[0].Y, newPnts[3].Z);
    // //var pnts3 = new Point3D(pnts[3].X, pnts[0].Y, pnts[3].Z);

    // Vector3D vecX = (Foot == "Right") ? Vector3D.AxisX : Vector3D.AxisMinusX;
    // //var ang = Utility.VectorsAngle(new Vector3D(newPnts[0], pnts1), new Vector3D(pnts2, pnts3), new Plane(Vector3D.AxisY));
    // var ang = Utility.VectorsAngle(vecX, new Vector3D(pnts2, pnts3), new Plane(Vector3D.AxisY));
    // ang = Math.Abs(ang);

    // LeaderAndText lbl = new LeaderAndText(pnts[2],
    //                       Math.Round(ang) + "°", new Font("Tahoma", 8.25f), Color.White, new Vector2D(0, 40));

    // lbl.FillColor = mcolor;
    // _labels.Add(lbl);

    // var scr = (int)Math.Round(CalcPositionItems[0].CoefVal * (ang + CalcPositionItems[0].ConstantVal));
    outputEnt.add(pntsmesh, d1, d2, d3, d4);
    return outputEnt;
}


const FPIColors = {
    TalarHead: "red",
    ArchHeight: "Green",
    TransversePlane: "Brown",
    RearFootAlignment: "Blue",
    CalcaneousPosition: "DarkViolet"
} as const;
